import { DomainRule } from '../../types';

export const NameRequiredRuleKey = 'branchNameRequired';
export const BranchNameCharLimit = 'branchNameCharLimit';

export const NameRequiredRule = ({ names }: { names: string[] }): DomainRule => {
  const trimmedNames = names.map(s => s?.trim()).filter(s => s);
  if (!trimmedNames.length) {
    return {
      result: 'fail',
      ruleKey: NameRequiredRuleKey,
    };
  }

  const namesTooLong = trimmedNames.filter(s => s.length > 100);
  if (namesTooLong.length) {
    return {
      result: 'fail',
      ruleKey: BranchNameCharLimit,
    };
  }

  return {
    result: 'pass',
    ruleKey: undefined,
  };
};
